import { IAuth } from '@packlink/packlink-sdk';
import Cookies from 'js-cookie';

export function removeToken(): void {
    Cookies.remove('token');
    Cookies.remove('access_token');
    Cookies.remove('refresh_token');
}

export function getAuthorization(): IAuth | undefined {
    const token = Cookies.get('token');

    if (token) {
        return { token };
    }
    return undefined;
}
